import React, { useRef } from 'react';
import ActionButton from './ActionButton';
import postData from '../../../utilities/postData';

const ExportButton = ({
    filter,
    url,
    disabled,
    useFormPost
}) => {
    const formRef = useRef(null);

    const rootInputs = Object.keys(filter)
        .filter(i => i !== 'searchObject')
        .map((name, index) => {
            return (
                <input
                    key={`r${index}`}
                    name={name}
                    type="hidden"
                    value={filter[name]}
                />
            );
        });

    const searchInputs = filter.searchObject && Object.keys(filter.searchObject)
        .map((name, index) => {
            return (
                <input
                    key={`s${index}`}
                    name={`searchObject.${name}`}
                    type="hidden"
                    value={filter[name]}
                />
            );
        });

    return (useFormPost ? (
        <form method="post" action={url} ref={formRef}>
            {rootInputs}
            {searchInputs}
            <ActionButton
                title="Export"
                imgSource="/images/csv.svg"
                onClick={() => formRef.current.submit()}
                disabled={!window.biztrax.canExport || disabled} />
        </form>
    ) : (
        <ActionButton
            title="Export"
            imgSource="/images/csv.svg"
            onClick={() => postData(url, filter, null, null, false)}
            disabled={!window.biztrax.canExport || disabled} />
    )
    );
}


ExportButton.defaultProps = {
    disabled: false
}

export default ExportButton;